import TextInput from "components/app/function/TextInput";
import { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { AppLog } from "services";
import { useAppSelector } from "store/store";
import { RequestApi, RouteApi, StatusMsg } from "utils";
import { setRequestWorkflows, setUserShopPositions, setUserShopProfile } from "store/businessSuiteSlice";
import SwitchYesNoWithLabel from "components/app/function/SwitchYesNoWithLabel";
import InputHideShow from "components/app/function/InputHideShow";
import { SelectScrollable } from "components/app/function/SelectScrollable";
import InputSelectAutoSuggest from "components/app/function/InputSelectAutoSuggest";
import { currencyCode } from "utils/currencyCode";
import { Service } from "utils/services";
import { CircleAlert } from "lucide-react";
import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue } from "components/ui/select";

export default function SettingShopDetail({ shopId, warning, errorStatus }: { shopId: any; warning: any; errorStatus: any }) {
  const { token } = useAppSelector((state) => state.auth);
  const dispatch = useDispatch();
  const { userShopProfile, isSaveSetting, userShopPositions, requestWorkflows } = useAppSelector((state) => state.businessSuite);
  const handlePositionChange = (index: number, newValue: string) => {
    const updated = [...requestWorkflows];
    if (updated[index]) {
      updated[index] = { ...updated[index], approver_position: newValue };
      dispatch(setRequestWorkflows(updated));
    }
  };

  const handleApproverChange = (index: number, newValue: string) => {
    const updated = [...requestWorkflows];
    if (updated[index]) {
      updated[index] = { ...updated[index], approver_type: newValue };
      dispatch(setRequestWorkflows(updated));
    }
  };

  const submitUserShopSetting = async () => {
    try {
      let url: string = "";
      url = RouteApi.submitUpdateShopSetting;
      url += `token=${token}`;
      const data = {
        shop_id: shopId,
        shop: userShopProfile,
        request_workflows: requestWorkflows,
        // user_shop_positions: userShopPositions,
      };

      const response = await RequestApi(url, { data });
      if (response.status === "success") {
      } else {
        AppLog.show({ message: response.msg, status: StatusMsg.getType(response.status) });
      }
    } catch (error) {
      AppLog.show({
        message: `[submitUserShopSetting]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  useEffect(() => {
    if (isSaveSetting) {
      submitUserShopSetting();
    }
  }, [isSaveSetting]);

  const symbol = useMemo(() => {
    const currency = currencyCode?.find((currency) => currency.value === userShopProfile?.currency_code);
    return currency ? currency.symbol : "";
  }, [userShopProfile?.currency_code]);

  const exchangeSymbol = useMemo(() => {
    const currency = currencyCode?.find((currency) => currency.value === userShopProfile?.exchange_currency_code);
    return currency ? currency.symbol : "";
  }, [userShopProfile?.exchange_currency_code]);

  return (
    <>
      {warning ? (
        <div className="flex flex-col gap-2 items-center justify-center h-[70vh] w-full  ">
          <CircleAlert className="text-yellow-500 mx-auto w-[200px] h-[200px]" />
          <h1
            className={`text-[30px] font-semibold   ${
              errorStatus?.title === "success" || errorStatus?.title === "info" ? "text-green-500" : errorStatus?.title === "warning" ? "text-yellow-500" : "text-red-500"
            }`}
          >
            {errorStatus?.title === "success" ? "Success" : errorStatus?.title === "info" ? "Infomation" : errorStatus?.title === "warning" ? "Warning" : "Error"}
          </h1>
          <span className=" text-muted-foreground text-md pt-3 ">{errorStatus?.message}</span>
        </div>
      ) : (
        <>
          {userShopProfile ? (
            <div className="p-2 space-y-4 pe-5">
              <div className="space-y-2">
                <p className="font-semibold text-lg">Number Precision</p>
                <div className="grid grid-cols-3 gap-4">
                  <div>
                    <p className="mb-1">Quntity</p>
                    <TextInput
                      value={userShopProfile?.quantity_decimal}
                      onChange={(event) => {
                        const tmpUserShop = {
                          ...userShopProfile,
                          quantity_decimal: event.target.value,
                        };
                        dispatch(setUserShopProfile(tmpUserShop));
                      }}
                    />
                  </div>
                  <div>
                    <p className="mb-1">Price</p>
                    <TextInput
                      value={userShopProfile?.price_decimal}
                      onChange={(event) => {
                        const tmpUserShop = { ...userShopProfile };
                        tmpUserShop.price_decimal = event.target.value;
                        dispatch(setUserShopProfile(tmpUserShop));
                      }}
                    />
                  </div>

                  <div>
                    <p className="mb-1">Amount</p>
                    <TextInput
                      value={userShopProfile?.amount_decimal}
                      onChange={(event) => {
                        const tmpUserShop = { ...userShopProfile };
                        tmpUserShop.amount_decimal = event.target.value;
                        dispatch(setUserShopProfile(tmpUserShop));
                      }}
                    />
                  </div>
                </div>
              </div>
              {/* ------------- */}

              <div className="space-y-2">
                <p className="font-semibold text-lg">Currency</p>
                <div className="grid grid-cols-3 gap-4">
                  <div>
                    <p className="mb-1">Code</p>
                    <InputSelectAutoSuggest
                      value={userShopProfile?.currency_code}
                      onChange={(answer) => {
                        const tmpUserShop = { ...userShopProfile };
                        tmpUserShop.currency_code = answer.value;
                        dispatch(setUserShopProfile(tmpUserShop));
                      }}
                      datas={currencyCode.map((currency) => ({
                        value: currency.value,
                        label: currency.label,
                        symbol: currency.symbol,
                      }))}
                    />
                  </div>
                  <div>
                    <p className="mb-1">Symbol</p>
                    <TextInput value={symbol} disabled />
                  </div>

                  <div>
                    <p className="mb-1">Exchange Code</p>
                    <InputSelectAutoSuggest
                      value={userShopProfile?.exchange_currency_code}
                      onChange={(answer) => {
                        const tmpUserShop = { ...userShopProfile };
                        tmpUserShop.exchange_currency_code = answer.value;
                        dispatch(setUserShopProfile(tmpUserShop));
                      }}
                      datas={currencyCode.map((currency) => ({
                        value: currency.value,
                        label: currency.label,
                        symbol: currency.symbol,
                      }))}
                    />
                  </div>
                  <div>
                    <p className="mb-1">Exchange Symbol</p>
                    <TextInput value={exchangeSymbol} disabled />
                  </div>
                  <div>
                    <p className="mb-1">Exchange Rate</p>
                    <TextInput
                      value={Service.toInteger(userShopProfile?.exchange_rate)}
                      onChange={(event) => {
                        const tmpUserShop = { ...userShopProfile };

                        tmpUserShop.exchange_rate = event.target.value;
                        dispatch(setUserShopProfile(tmpUserShop));
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="space-y-2">
                <p className="font-semibold text-lg">Tax</p>
                <div className="grid grid-cols-3 gap-4">
                  <div>
                    <p className="mb-1">Registration No</p>
                    <TextInput
                      value={userShopProfile?.tax_registration_no}
                      onChange={(event) => {
                        const tmpUserShop = { ...userShopProfile };

                        tmpUserShop.tax_registration_no = event.target.value;
                        dispatch(setUserShopProfile(tmpUserShop));
                      }}
                    />
                  </div>

                  <div>
                    <p className="mb-1">Percentage</p>
                    <TextInput
                      value={Number(userShopProfile?.tax_percentage).toFixed(2)}
                      onChange={(event) => {
                        const tmpUserShop = { ...userShopProfile };

                        tmpUserShop.tax_percentage = event.target.value;
                        dispatch(setUserShopProfile(tmpUserShop));
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="space-y-2">
                <p className="font-semibold text-lg">Payment Method</p>
                <div>
                  <p className="mb-1">Bank account</p>
                  <TextInput
                    value={userShopProfile?.bank_account}
                    onChange={(event) => {
                      const tmpUserShop = { ...userShopProfile };
                      tmpUserShop.bank_account = event.target.value;
                      dispatch(setUserShopProfile(tmpUserShop));
                    }}
                  />
                </div>
                <div className="grid grid-cols-3 gap-4">
                  <div className="flex justify-between items-center">
                    <div className="w-full capitalize mt-[13px] bg-gray-100 dark:border-[1px] dark:border-gray-200 dark:bg-transparent rounded-md">
                      <SwitchYesNoWithLabel
                        icon={""}
                        id="bank_payment"
                        label="Bank Payment"
                        value={userShopProfile?.bank_payment}
                        onChange={(answer: string) => {
                          const tmpUserShop = { ...userShopProfile };

                          tmpUserShop.tax_percentage = answer;
                          dispatch(setUserShopProfile(tmpUserShop));
                        }}
                      />
                    </div>
                  </div>

                  <div className="flex justify-between items-center">
                    <div className="w-full capitalize mt-[13px] bg-gray-100 dark:border-[1px] dark:border-gray-200 dark:bg-transparent rounded-md">
                      <SwitchYesNoWithLabel
                        icon={""}
                        id="credit-card-payment"
                        label="Credit Card Payment"
                        value={userShopProfile?.credit_card_payment}
                        onChange={(answer: string) => {
                          const tmpUserShop = { ...userShopProfile };

                          tmpUserShop.credit_card_payment = answer;
                          dispatch(setUserShopProfile(tmpUserShop));
                        }}
                      />
                    </div>
                  </div>

                  <div className="flex justify-between items-center">
                    <div className="w-full capitalize mt-[13px] bg-gray-100 dark:border-[1px] dark:border-gray-200 dark:bg-transparent rounded-md">
                      <SwitchYesNoWithLabel
                        icon={""}
                        id="currency-payment"
                        label="Currency Payment"
                        value={userShopProfile?.currency_payment}
                        onChange={(answer) => {
                          const tmpUserShop = { ...userShopProfile };

                          tmpUserShop.currency_payment = answer;
                          dispatch(setUserShopProfile(tmpUserShop));
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="space-y-2">
                <p className="font-semibold text-lg">Delivery Agency</p>

                <div className="grid grid-cols-3 gap-4">
                  <div className="flex justify-between items-center">
                    <div className="w-full capitalize mt-[13px] bg-gray-100 dark:border-[1px] dark:border-gray-200 dark:bg-transparent rounded-md">
                      <SwitchYesNoWithLabel
                        icon={""}
                        id="food-panda"
                        label="Food Panda"
                        value={userShopProfile?.foodpanda}
                        onChange={(answer) => {
                          const tmpUserShop = { ...userShopProfile };

                          tmpUserShop.foodpanda = answer;
                          dispatch(setUserShopProfile(tmpUserShop));
                        }}
                      />
                    </div>
                  </div>

                  <div className="flex justify-between items-center">
                    <div className="w-full capitalize mt-[13px] bg-gray-100 dark:border-[1px] dark:border-gray-200 dark:bg-transparent rounded-md">
                      <SwitchYesNoWithLabel
                        icon={""}
                        id="nham24"
                        label="Nham24"
                        value={userShopProfile?.nham24}
                        onChange={(answer) => {
                          const tmpUserShop = { ...userShopProfile };

                          tmpUserShop.nham24 = answer;
                          dispatch(setUserShopProfile(tmpUserShop));
                        }}
                      />
                    </div>
                  </div>

                  <div className="flex justify-between items-center">
                    <div className="w-full capitalize mt-[13px] bg-gray-100 dark:border-[1px] dark:border-gray-200 dark:bg-transparent rounded-md">
                      <SwitchYesNoWithLabel
                        icon={""}
                        id="meal-temple"
                        label="Meal Temple"
                        value={userShopProfile?.meal_temple}
                        onChange={(answer) => {
                          const tmpUserShop = { ...userShopProfile };

                          tmpUserShop.meal_temple = answer;
                          dispatch(setUserShopProfile(tmpUserShop));
                        }}
                      />
                    </div>
                  </div>

                  <div className="flex justify-between items-center">
                    <div className="w-full capitalize mt-[13px] bg-gray-100 dark:border-[1px] dark:border-gray-200 dark:bg-transparent rounded-md">
                      <SwitchYesNoWithLabel
                        icon={""}
                        id="egets"
                        label="Egets"
                        value={userShopProfile?.e_gets}
                        onChange={(answer) => {
                          console.log("answer");
                          const tmpUserShop = { ...userShopProfile };

                          tmpUserShop.e_gets = answer;
                          dispatch(setUserShopProfile(tmpUserShop));
                        }}
                      />{" "}
                    </div>
                  </div>

                  <div className="flex justify-between items-center">
                    <div className="w-full capitalize mt-[13px] bg-gray-100 dark:border-[1px] dark:border-gray-200 dark:bg-transparent rounded-md">
                      <SwitchYesNoWithLabel
                        icon={""}
                        id="muuve"
                        label="Muuve"
                        value={userShopProfile?.muuve}
                        onChange={(answer) => {
                          const tmpUserShop = { ...userShopProfile };

                          tmpUserShop.muuve = answer;
                          dispatch(setUserShopProfile(tmpUserShop));
                        }}
                      />
                    </div>
                  </div>

                  <div className="flex justify-between items-center">
                    <div className="w-full capitalize mt-[13px] bg-gray-100 dark:border-[1px] dark:border-gray-200 dark:bg-transparent rounded-md">
                      <SwitchYesNoWithLabel
                        icon={""}
                        id="instafood"
                        label="Instafood"
                        value={userShopProfile?.instafood}
                        onChange={(answer) => {
                          const tmpUserShop = { ...userShopProfile };

                          tmpUserShop.instafood = answer;
                          dispatch(setUserShopProfile(tmpUserShop));
                        }}
                      />
                    </div>
                  </div>

                  <div className="flex justify-between items-center">
                    <div className="w-full capitalize mt-[13px] bg-gray-100 dark:border-[1px] dark:border-gray-200 dark:bg-transparent rounded-md">
                      <SwitchYesNoWithLabel
                        icon={""}
                        id="the-speed-delivery"
                        label="The Speed Delivery"
                        value={userShopProfile?.the_speed_delivery}
                        onChange={(answer) => {
                          const tmpUserShop = { ...userShopProfile };

                          tmpUserShop.the_speed_delivery = answer;
                          dispatch(setUserShopProfile(tmpUserShop));
                        }}
                      />
                    </div>
                  </div>

                  <div className="flex justify-between items-center">
                    <div className="w-full capitalize mt-[13px] bg-gray-100 dark:border-[1px] dark:border-gray-200 dark:bg-transparent rounded-md">
                      <SwitchYesNoWithLabel
                        icon={""}
                        id="bloc"
                        label="Bloc"
                        value={userShopProfile?.bloc}
                        onChange={(answer) => {
                          const tmpUserShop = { ...userShopProfile };

                          tmpUserShop.bloc = answer;
                          dispatch(setUserShopProfile(tmpUserShop));
                        }}
                      />
                    </div>
                  </div>

                  <div className="flex justify-between items-center">
                    <div className="w-full capitalize mt-[13px] bg-gray-100 dark:border-[1px] dark:border-gray-200 dark:bg-transparent rounded-md">
                      <SwitchYesNoWithLabel
                        icon={""}
                        id="grabfood"
                        label="Grabfood"
                        value={userShopProfile?.grabfood}
                        onChange={(answer) => {
                          const tmpUserShop = { ...userShopProfile };

                          tmpUserShop.grabfood = answer;
                          dispatch(setUserShopProfile(tmpUserShop));
                        }}
                      />
                    </div>
                  </div>

                  <div className="flex justify-between items-center">
                    <div className="w-full capitalize mt-[13px] bg-gray-100 dark:border-[1px] dark:border-gray-200 dark:bg-transparent rounded-md">
                      <SwitchYesNoWithLabel
                        icon={""}
                        id="wownow"
                        label="Wownow"
                        value={userShopProfile?.wownow}
                        onChange={(answer) => {
                          const tmpUserShop = { ...userShopProfile };

                          tmpUserShop.wownow = answer;
                          dispatch(setUserShopProfile(tmpUserShop));
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="space-y-2">
                <p className="font-semibold text-lg">Booking</p>
                <div className="grid grid-cols-3 gap-4">
                  <div>
                    <p className="mb-1">Max. No of Pax</p>
                    <TextInput
                      value={userShopProfile?.max_no_of_pax}
                      onChange={(event) => {
                        const tmpUserShop = { ...userShopProfile };

                        tmpUserShop.max_no_of_pax = event.target.value;
                        dispatch(setUserShopProfile(tmpUserShop));
                      }}
                    />
                  </div>

                  <div className="flex justify-between items-center">
                    <div className="w-full capitalize mt-[25px] bg-gray-100 dark:border-[1px] dark:border-gray-200 dark:bg-transparent rounded-md">
                      <SwitchYesNoWithLabel
                        icon={""}
                        id="allow-booking"
                        label="Allow Booking"
                        value={userShopProfile?.allow_booking}
                        onChange={(answer) => {
                          const tmpUserShop = { ...userShopProfile };

                          tmpUserShop.allow_booking = answer;
                          dispatch(setUserShopProfile(tmpUserShop));
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="space-y-2">
                <p className="font-semibold text-lg">Permission</p>
                <div className="grid grid-cols-3 gap-4">
                  <div className="flex justify-between items-center">
                    <div className="w-full capitalize mt-[13px] bg-gray-100 dark:border-[1px] dark:border-gray-200 dark:bg-transparent rounded-md">
                      <SwitchYesNoWithLabel
                        icon={""}
                        id="allow-cashier-voic-invoice"
                        label=" Cashier Void Invoice"
                        value={userShopProfile?.allow_cashier_void_invoice}
                        onChange={(answer: string) => {
                          const tmpUserShop = { ...userShopProfile };

                          tmpUserShop.allow_cashier_void_invoice = answer;
                          dispatch(setUserShopProfile(tmpUserShop));
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="space-y-2">
                <p className="font-semibold text-lg">Passcode</p>
                <div className="grid grid-cols-3 gap-4">
                  <div>
                    <p className="mb-1">Admin passcode</p>
                    <InputHideShow
                      maxLength={5}
                      minLength={5}
                      value={userShopProfile?.admin_passcode}
                      onChange={(event) => {
                        const tmpUserShop = { ...userShopProfile };

                        tmpUserShop.admin_passcode = event.target.value;
                        dispatch(setUserShopProfile(tmpUserShop));
                      }}
                    />
                  </div>
                  <div>
                    <p className="mb-1">Cashier Passcode</p>
                    <InputHideShow
                      maxLength={5}
                      minLength={5}
                      value={userShopProfile?.cashier_passcode}
                      onChange={(event) => {
                        const tmpUserShop = { ...userShopProfile };

                        tmpUserShop.cashier_passcode = event.target.value;
                        dispatch(setUserShopProfile(tmpUserShop));
                      }}
                      placeholder=""
                    />
                  </div>

                  <div>
                    <p className="mb-1">Order Passcode</p>
                    <InputHideShow
                      maxLength={5}
                      minLength={5}
                      value={userShopProfile?.order_passcode}
                      onChange={(event) => {
                        const tmpUserShop = { ...userShopProfile };

                        tmpUserShop.order_passcode = event.target.value;
                        dispatch(setUserShopProfile(tmpUserShop));
                      }}
                      placeholder=""
                    />
                  </div>
                </div>
              </div>

              <div className="space-y-2">
                <p className="font-semibold text-lg">Telegram Report</p>
                <div className="grid grid-cols-3 gap-4">
                  <div>
                    <p className="mb-1">Telegram Group ID</p>
                    <TextInput
                      value={userShopProfile?.telegram_group_id}
                      onChange={(event) => {
                        const tmpUserShop = { ...userShopProfile };

                        tmpUserShop.telegram_group_id = event.target.value;
                        dispatch(setUserShopProfile(tmpUserShop));
                      }}
                      placeholder=""
                    />
                  </div>

                  <div>
                    <p className="mb-1">Telegram Channel ID</p>
                    <TextInput
                      value={userShopProfile?.telegram_channel_id}
                      onChange={(event) => {
                        const tmpUserShop = { ...userShopProfile };

                        tmpUserShop.telegram_channel_id = event.target.value;
                        dispatch(setUserShopProfile(tmpUserShop));
                      }}
                      placeholder=""
                    />
                  </div>

                  <div>
                    <p className="mb-1">Telegram User ID</p>
                    <TextInput
                      value={userShopProfile?.telegram_user_id}
                      onChange={(event) => {
                        const tmpUserShop = { ...userShopProfile };

                        tmpUserShop.telegram_user_id = event.target.value;
                        dispatch(setUserShopProfile(tmpUserShop));
                      }}
                      placeholder=""
                    />
                  </div>

                  <div>
                    <p className="mb-1">Shift Close Summary</p>
                    <SelectScrollable
                      datas={[
                        { value: "Group", label: "Group" },
                        { value: "Item", label: "Item" },
                      ]}
                      value={userShopProfile?.shift_close_summary_by}
                      onChange={(answer: string) => {
                        const tmpUserShop = { ...userShopProfile };

                        tmpUserShop.shift_close_summary_by = answer;
                        dispatch(setUserShopProfile(tmpUserShop));
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="space-y-2">
                <p className="font-semibold text-lg">Layout</p>
                <div className="grid grid-cols-3 gap-4">
                  <div>
                    <p className="mb-1">No. of Table Layout</p>
                    <TextInput
                      value={userShopProfile?.no_of_table_layout}
                      onChange={(event) => {
                        const tmpUserShop = { ...userShopProfile };

                        tmpUserShop.no_of_table_layout = event.target.value;
                        dispatch(setUserShopProfile(tmpUserShop));
                      }}
                    />
                  </div>
                  <div>
                    <p className="mb-1">No. of Item Layout</p>
                    <TextInput
                      value={userShopProfile?.no_of_item_layout}
                      onChange={(event) => {
                        const tmpUserShop = { ...userShopProfile };

                        tmpUserShop.no_of_item_layout = event.target.value;
                        dispatch(setUserShopProfile(tmpUserShop));
                      }}
                    />
                  </div>

                  <div>
                    <p className="mb-1">No. of Item Display Layout</p>
                    <TextInput
                      value={userShopProfile?.no_of_item_display_layout}
                      onChange={(event) => {
                        const tmpUserShop = { ...userShopProfile };

                        tmpUserShop.no_of_item_display_layout = event.target.value;
                        dispatch(setUserShopProfile(tmpUserShop));
                      }}
                    />
                  </div>

                  <div className="flex justify-between items-center">
                    <div className="w-full capitalize mt-[13px] bg-gray-100 dark:border-[1px] dark:border-gray-200 dark:bg-transparent rounded-md">
                      <SwitchYesNoWithLabel
                        icon={""}
                        id="popup_input_quantity"
                        label="Popup Input Qauntity"
                        value={userShopProfile?.popup_input_quantity}
                        onChange={(answer) => {
                          const tmpUserShop = { ...userShopProfile };

                          tmpUserShop.popup_input_quantity = answer;
                          dispatch(setUserShopProfile(tmpUserShop));
                        }}
                      />
                    </div>
                  </div>

                  <div className="flex justify-between items-center">
                    <div className="w-full capitalize mt-[13px] bg-gray-100 dark:border-[1px] dark:border-gray-200 dark:bg-transparent rounded-md">
                      <SwitchYesNoWithLabel
                        icon={""}
                        id="customer_display"
                        label="Customer Display"
                        value={userShopProfile?.customer_display}
                        onChange={(answer) => {
                          const tmpUserShop = { ...userShopProfile };

                          tmpUserShop.customer_display = answer;
                          dispatch(setUserShopProfile(tmpUserShop));
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="space-y-2">
                <p className="font-semibold text-lg">Printing</p>
                <div className="grid grid-cols-3 gap-4">
                  <div>
                    <p className="mb-1">Invoice Printer IP</p>
                    <TextInput
                      value={userShopProfile?.invoice_printer_ip}
                      onChange={(event) => {
                        const tmpUserShop = { ...userShopProfile };

                        tmpUserShop.invoice_printer_ip = event.target.value;
                        dispatch(setUserShopProfile(tmpUserShop));
                      }}
                    />
                  </div>
                  <div>
                    <p className="mb-1">Invoice Printer Delay</p>
                    <TextInput
                      value={userShopProfile?.invoice_printer_delay}
                      onChange={(event) => {
                        const tmpUserShop = { ...userShopProfile };

                        tmpUserShop.invoice_printer_delay = event.target.value;
                        dispatch(setUserShopProfile(tmpUserShop));
                      }}
                    />
                  </div>

                  <div>
                    <p className="mb-1">Invoice Layout Quality</p>
                    <TextInput
                      value={userShopProfile?.invoice_layout_quality}
                      onChange={(event) => {
                        const tmpUserShop = { ...userShopProfile };

                        tmpUserShop.invoice_layout_quality = event.target.value;
                        dispatch(setUserShopProfile(tmpUserShop));
                      }}
                    />
                  </div>

                  <div>
                    <p className="mb-1">Invoice Layout</p>
                    <SelectScrollable
                      datas={[{ value: "Default", label: "Default" }]}
                      value={userShopProfile?.invoice_layout}
                      onChange={(answer: string) => {
                        const tmpUserShop = { ...userShopProfile };

                        tmpUserShop.invoice_layout = answer;
                        dispatch(setUserShopProfile(tmpUserShop));
                      }}
                    />
                  </div>

                  <div className="flex justify-between items-center">
                    <div className="w-full capitalize mt-[25px] bg-gray-100 dark:border-[1px] dark:border-gray-200 dark:bg-transparent rounded-md">
                      <SwitchYesNoWithLabel
                        icon={""}
                        id="invoice_printer"
                        label="Invoice Printer"
                        value={userShopProfile?.invoice_printer}
                        onChange={(answer: string) => {
                          const tmpUserShop = { ...userShopProfile };

                          tmpUserShop.invoice_printer = answer;
                          dispatch(setUserShopProfile(tmpUserShop));
                        }}
                      />
                    </div>
                  </div>

                  <div className="flex justify-between items-center">
                    <div className="w-full capitalize mt-[25px] bg-gray-100 dark:border-[1px] dark:border-gray-200 dark:bg-transparent rounded-md">
                      <SwitchYesNoWithLabel
                        icon={""}
                        id="invoice_preview"
                        label="Invoice Preview"
                        value={userShopProfile?.invoice_preview}
                        onChange={(answer: string) => {
                          const tmpUserShop = { ...userShopProfile };

                          tmpUserShop.invoice_preview = answer;
                          dispatch(setUserShopProfile(tmpUserShop));
                        }}
                      />
                    </div>
                  </div>

                  <div>
                    <p className="mb-1">Invoice Prefix</p>
                    <TextInput
                      value={userShopProfile?.invoice_prefix}
                      onChange={(event) => {
                        const tmpUserShop = { ...userShopProfile };

                        tmpUserShop.invoice_prefix = event.target.value;
                        dispatch(setUserShopProfile(tmpUserShop));
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="space-y-2">
                <p className="font-semibold text-lg">Approval Workflow</p>

                <div className="flex items-center justify-between w-full ">
                  <div className=" py-1 ">
                    <table className="min-w-full border-collapse  rounded-md overflow-hidden mt-2">
                      <thead className="sticky top-0 left-0 text-xs text-gray-700  bg-gray-300 dark:bg-[#2c3a52] dark:text-gray-400">
                        <tr className="border-none text-[15px] text-start  ">
                          <th className="px-4 py-3 text-start">Application Type</th>
                          <th className="px-4 py-3 text-start">Approver</th>
                          <th className=" py-3 px-4 text-start">Position</th>
                        </tr>
                      </thead>
                      <tbody>
                        {requestWorkflows?.map((item: any, index: number) => {
                          return (
                            <tr
                              key={index}
                              className={`text-center group ${index % 2 === 0 ? "bg-gray-100 dark:bg-[#1e293b]" : "bg-gray-200 dark:bg-[#2c3a52]"} hover:bg-gray-300`}
                            >
                              <td className="py-2 px-4 text-left align-top">
                                <p className=" my-1 inline-block rounded-md py-1 font-semibold text-sm line-clamp-1 text-nowrap">{item?.request_type}</p>
                              </td>
                              <td className="py-2 px-4 text-center flex items-end justify-end  align-top">
                                <Select value={item.approver_type} onValueChange={(val) => handleApproverChange(index, val)}>
                                  <SelectTrigger className="w-[150px]">
                                    <SelectValue />
                                  </SelectTrigger>
                                  <SelectContent>
                                    <SelectGroup>
                                      {["None", "Required"].map((option, idx) => (
                                        <SelectItem key={idx} value={option}>
                                          {option}
                                        </SelectItem>
                                      ))}
                                    </SelectGroup>
                                  </SelectContent>
                                </Select>
                              </td>
                              <td className="py-2 px-4 text-left align-top">
                                <Select
                                  value={item.approver_position?.toLowerCase() === "direct line manager" ? "direct_line_manager" : item.approver_position || ""}
                                  onValueChange={(val) => handlePositionChange(index, val)}
                                >
                                  <SelectTrigger className="w-[300px]">
                                    <SelectValue placeholder="Select position" />
                                  </SelectTrigger>
                                  <SelectContent>
                                    <SelectGroup>
                                      <SelectItem value="direct_line_manager">Direct Line Manager</SelectItem>
                                      {userShopPositions
                                        ?.filter((posItem: any) => !!posItem.position) // filter out blank/undefined
                                        .map((posItem: any, idx: number) => (
                                          <SelectItem key={idx} value={posItem.position}>
                                            {posItem.position}
                                          </SelectItem>
                                        ))}
                                    </SelectGroup>
                                  </SelectContent>
                                </Select>
                              </td>
                              {/* <td className="py-2 px-4 text-center flex items-end justify-end  align-top">
                               
                              </td> */}
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <></>
          )}
        </>
      )}
    </>
  );
}
